import { getCountryOptions, getTimezoneOptions, ORG_NICHE_OPTIONS } from '@jq4race/shared';

// Sourced from the shared geo registry (packages/shared/src/geo) — only the
// United States is enabled today. Enabling another country is a matter of
// appending one entry to SUPPORTED_COUNTRIES, not touching this file.

export const COUNTRY_OPTIONS: ReadonlyArray<{ code: string; label: string }> =
  getCountryOptions().map((o) => ({ code: o.value, label: o.label }));

export const TIMEZONE_OPTIONS: ReadonlyArray<{ value: string; label: string }> =
  getTimezoneOptions();

// Niche options are the shared source of truth (packages/shared/src/org-schemas.ts) —
// do not hardcode a local union here.
export const NICHE_OPTIONS = ORG_NICHE_OPTIONS;
